/** Плоские data-testid RowDivider (shared Tree). */
export const rowDividerTestIds = {
    root: 'RowDivider',
    hoverTarget: 'RowDividerHoverTarget',
    displaySequenceAttr: 'data-display-sequence',
} as const;
